import { browser } from '$app/environment';
import { characterIndex, initIndexes, itemIndex } from '$lib/search/search';
import type { LayoutLoad } from './$types';
import { getItemName } from '$lib/er/item/translation';
import { getTranslatedCharacterName } from '$lib/er/character/translations';
import { i18nObject } from '$i18n/i18n-util';
import { api } from '$lib/erar/api';
import { get } from 'svelte/store';
import { idToItem } from '$lib/er/item/stores';
import { idToCharacter } from '$lib/er/character/stores';

export const load: LayoutLoad = async ({ fetch, parent }) => {
  const { locale } = await parent();

  initIndexes(locale);

  if (browser) {
    const LL = i18nObject(locale);

    for (const item of get(idToItem).values()) {
      if (itemIndex.contain(item.id)) {
        itemIndex.update(item.id, getItemName(LL, item.id));
      } else {
        itemIndex.add(item.id, getItemName(LL, item.id));
      }
    }

    for (const character of get(idToCharacter).values()) {
      if (characterIndex.contain(character.id)) {
        characterIndex.update(character.id, getTranslatedCharacterName(LL, character.id));
      } else {
        characterIndex.add(character.id, getTranslatedCharacterName(LL, character.id));
      }
    }
  }

  const status = await api('GET /status', { fetch });

  return {
    status,
  };
};
